import { Block, Typography } from "@xprog/prensa";
import { PrensaEngineCSSProp } from "@xprog/prensa/types";
import CallToActionOutlinedButton from "components/Buttons/CallToActionOutlinedButton.index";
import React from "react";
import { useIcon } from "hooks/useIcon";
import Icon from "components/Icon/Icon.index";

const ButtonDefault: React.FC<any> = ({ children, onClick }) => {
  return (
    <CallToActionOutlinedButton
      onClick={onClick}
      css={{
        button: {
          borderColor: "#164194",
          height: "42px",
          width: "210px",
        },
        label: {
          color: "#164194",
        },
      }}
    >
      {children}
    </CallToActionOutlinedButton>
  );
};
const Container: React.FC<React.PropsWithChildren> = ({ children }) => {
  const containerStyles: PrensaEngineCSSProp = {
    align: ['column', 'center', 'top'],
    background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 20%)',
    minHeight: '240px',
    position: 'relative',
    paddingTop: '175px',
    marginTop: '-275px',
    width: '100%'
  }

  return <Block css={containerStyles}>{children}</Block>;
};
const ColumnHolder: React.FC<React.PropsWithChildren> = ({ children }) => {
  const columnHolderCSS: PrensaEngineCSSProp = {
    align: ["column", "center", "top"],
    width: "100%",
    "div:first-child": {
      mb: "$8",
    },
    "@lg": {
      align: ["row", "center", "top"],
      "div:nth-child(2)": {
        borderLeft: "1px solid #E6E6E6",
      },
    },
  };
  return <Block css={columnHolderCSS}>{children}</Block>;
};
const Column: React.FC<
  { customCss?: PrensaEngineCSSProp } & React.PropsWithChildren
> = ({ children, customCss }) => {
  return (
    <Block
      css={{
        align: ["column", "center", "top"],
        px: "$8",
        maxWidth: "306px",
        "@lg": {
          width: "calc(50% - $16)",
        },
        ...customCss,
      }}
    >
      {children}
    </Block>
  );
};
const KeyHolder: React.FC<React.PropsWithChildren> = ({ children }) => {
  const columnHolderCSS: PrensaEngineCSSProp = {
    align: ["row", "center", "top"],
    mb: "$4",
    width: "100%",
  };
  return <Block css={columnHolderCSS}>{children}</Block>;
};

const KeyIcon: React.FC<{ used: boolean }> = ({ used }) => {
  const iconChave = useIcon("IcChave");
  const iconChaveAzul = useIcon("IcChaveAzul");
  const keyIconGray = () => <Icon {...iconChave} height="24px" width="58px" />;
  const keyIconBlue = () => (
    <Icon {...iconChaveAzul} height="24px" width="58px" />
  );
  return <Typography>{used ? keyIconBlue() : keyIconGray()}</Typography>;
};
const MainTitle: React.FC<
  { customCss?: PrensaEngineCSSProp } & React.PropsWithChildren
> = ({ children, customCss }) => {
  const mainTitleCSS: PrensaEngineCSSProp = {
    color: "black",
    fontWeight: 700,
    fontSize: "30px",
    lineHeight: "43px",
    fontFamily: "$primary",
    textAlign: "center",
    ...customCss,
  };
  return <Typography css={mainTitleCSS}>{children}</Typography>;
};
const SubTitle: React.FC<React.PropsWithChildren> = ({ children }) => {
  const subTitleCSS: PrensaEngineCSSProp = {
    color: "black",
    fontFamily: "$primary",
    fontSize: "22px",
    fontWeight: 500,
    lineHeight: "35px",
    letterSpacing: "0.6px",
    my: "$0",
    textAlign: "center",
  };
  return <Typography css={subTitleCSS}>{children}</Typography>;
};
const SubText: React.FC<{
  children: string;
  customCss?: PrensaEngineCSSProp;
}> = ({ children, customCss }) => {
  const subTextCSS: PrensaEngineCSSProp = {
    color: "#4D4D4D",
    fontFamily: "$primary",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "17px",
    letterSpacing: "0.2px",
    textAlign: "center",
    strong: {
      color: "#164194",
    },
    "@lg": {
      minHeight: "50px",
    },
    ...customCss,
  };
  return (
    <Typography
      css={subTextCSS}
      dangerouslySetInnerHTML={{ __html: children }}
    />
  );
};
export {
  ButtonDefault,
  Container,
  ColumnHolder,
  Column,
  KeyHolder,
  KeyIcon,
  MainTitle,
  SubTitle,
  SubText,
};
